var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.element.src)?_c('div',{ref:_vm.refName,staticClass:"animate-layer",class:[_vm.element.position, _vm.navId]},[_c('img',{attrs:{"src":_vm.loadFile}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }